module.exports = __webpack_public_path__ + "img/Testunlockgreen.279d4803.svg";